import GuyWithLaptopIcon from 'svg/GuyWithLaptopIcon';
import styles from './UsersTableEmptyState.module.css';

export const UsersTableEmptyState = () => {
  return (
    <div className={styles.content}>
      <GuyWithLaptopIcon className={styles.icon} />
      <p className={styles.text}>No users found</p>
      <p className={styles.subText}>
        Check for typos or try a different name or email address.
      </p>
    </div>
  );
};
